module.exports = __webpack_public_path__ + "media/images/new_landing/about/story-hero-7b1fe39762224aef35326699d8bf34e3.jpg";